module.exports = __webpack_public_path__ + "static/media/messy-icon.c229f899.svg";